import styled from 'styled-components';

export const Container = styled.div.attrs({
  className: 'container',
})``;

export const PropertiesCardWrapper = styled.div``;
